import React, { type ReactNode } from "react";
import AttributeFilterModalContent from "components/source/new_taxonomy/attribute-filter-modal-content";
import ClosableModal from "components/source/shared/closable-modal";
import type { FilterOptions } from "components/types/filter-options";
import type { WorkingFilters } from "components/types/working-filters";

export type FilterModalProps = {
  clearAttributeFilters: () => void;
  displayedModal: string | boolean;
  expandFilters: () => void;
  filterOptions: FilterOptions;
  getFieldsetHeader: (fieldset: string) => string;
  isDeadEndTextSearch: boolean;
  isFilterOpen: (filter: string) => boolean;
  isMobileViewport: boolean;
  noPriceSortDropdownMenu: boolean;
  onChangeSort: () => void;
  onFilterChange: (filter: { filterGroupKey: string; name: string; selected?: boolean }) => void;
  onRequestClose: () => void;
  onToggleOpenFilters: () => void;
  renderRTRFilters: () => ReactNode;
  renderSpecialFields: () => ReactNode;
  selectedSort: string;
  showLimitedFilterSet: boolean;
  showSizeFilter: boolean;
  submitFilters: () => void;
  updateGridProducts: () => void;
  /**
   * This needs to be a prop because of course Swaps grid doesn't read from Redux workingFilters.
   */
  workingFilters: WorkingFilters;
};

const FilterModal = (props: FilterModalProps) => {
  const className = "FilterModal";
  const modalName = "filter-modal";
  const desktopStyles = {
    maxWidth: "30.5rem",
    inset: "auto 0 auto auto",
  };
  const styles = {
    content: {
      padding: 0,
      height: "100%",
      transform: "unset",
      inset: "unset",
      ...(!props.isMobileViewport && desktopStyles),
    },
  };

  return (
    <div data-test-id="filter-modal">
      {props.displayedModal === modalName && (
        // TODO: is this props spread ok?
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ClosableModal optionalClass={className} additionalStyles={styles} isOpen={true} {...props}>
          <AttributeFilterModalContent
            closeModal={props.onRequestClose}
            expandFilters={props.expandFilters}
            filterOptions={props.filterOptions}
            getFieldsetHeader={props.getFieldsetHeader}
            isDeadEndTextSearch={props.isDeadEndTextSearch}
            isFilterOpen={props.isFilterOpen}
            noPriceSortDropdownMenu={props.noPriceSortDropdownMenu}
            onChange={props.onFilterChange}
            onChangeSort={props.onChangeSort}
            onClearFilters={props.clearAttributeFilters}
            onToggleOpenFilters={props.onToggleOpenFilters}
            renderRTRFilters={props.renderRTRFilters}
            renderSpecialFields={props.renderSpecialFields}
            selectedSort={props.selectedSort}
            showLimitedFilterSet={props.showLimitedFilterSet}
            showSizeFilter={props.showSizeFilter}
            submitFilters={props.submitFilters}
            updateGridProducts={props.updateGridProducts}
            workingFilters={props.workingFilters}
          />
        </ClosableModal>
      )}
    </div>
  );
};

export default FilterModal;
